// extracted by mini-css-extract-plugin
export var KPM = "KPM-aff";
export var navigation_item_active = "navigation_item_active-qwV";
export var side_navigation = "side_navigation-u0x";
export var side_navigation_mobile = "side_navigation_mobile-zhK";